import React, { useState } from "react";
import InputComponent from "V2.0/components/InputComponent";
import { putVoiceSettings } from "../service";
import { message } from "antd";

export function ShowOriginalCallerID(props) {
  const { showOriginalCallerId, workspaceId, assistantId, syncAssistant } =
    props;
  const [state, setState] = useState(showOriginalCallerId);

  const updateVoiceSettings = async (payload) => {
    try {
      const response = await putVoiceSettings({
        workspaceId,
        assistantId,
        payload,
      });
      if (response.status === 200) {
        syncAssistant((prevAssistant) => {
          return {
            ...prevAssistant,
            voiceSettings: response.data,
          };
        });
      }
    } catch (e) {
      message.error(
        e.response.data?.msg || e.response.data?.message || e.response.data?.error || "Failed to update Show Original Caller ID"
      );
    }
  };

  const onToggle = () => {
    setState((prevState) => !prevState);
    const payload = {
      showOriginalCallerId: !state,
    };
    updateVoiceSettings(payload);
  };

  return (
    <div className="flex flex-col gap-y-2">
      <InputComponent
        name="Show Original caller ID"
        label="Show Original Caller ID"
        value={state}
        onChange={onToggle}
        type="toggle"
        description="Show caller's number on call transfer. If switched off, the Twilio number associated with the workspace will be shown"
      />
    </div>
  );
}
